// BRI Authentication Configuration
export const authConfig = {
  // Base URLs from environment variables with fallbacks
  authBaseUrl: process.env.REACT_APP_BRI_AUTH_BASE_URL || 'https://auth.bellomyonline.com',
  apiBaseUrl: process.env.REACT_APP_BRI_API_BASE_URL || 'https://authapi.bellomyonline.com',
  
  // Audience - check query string first, then localStorage, then environment variable
  get audience() {
    // Check URL query parameters first
    const urlParams = new URLSearchParams(window.location.search);
    const queryAudience = urlParams.get('audience');
    
    if (queryAudience) {
      // Save to localStorage for persistence
      localStorage.setItem('bri_saved_audience', queryAudience);
      return queryAudience;
    }
    
    // Check localStorage for previously saved audience
    const savedAudience = localStorage.getItem('bri_saved_audience');
    if (savedAudience) {
      return savedAudience;
    }
    
    // Fall back to environment variable
    return process.env.REACT_APP_BRI_AUDIENCE || 'BRI';
  },
  
  // Method to clear saved audience
  clearSavedAudience() {
    localStorage.removeItem('bri_saved_audience');
  },
  
  // Method to get saved audience (for UI display)
  getSavedAudience(): string | null {
    return localStorage.getItem('bri_saved_audience');
  },
  
  // Constructed endpoint URLs
  get loginUrl() {
    return `${this.authBaseUrl}`;
  },
  
  get refreshUrl() {
    return `${this.apiBaseUrl}/refresh?audience=${this.audience}`;
  },
  
  get verifyUrl() {
    return `${this.apiBaseUrl}/verify?audience=${this.audience}`;
  },
  
  get logoutUrl() {
    return `${this.apiBaseUrl}/logout`;
  }
};

export default authConfig;

